module.exports = __webpack_public_path__ + "static/media/hair-care.fc7ed5ae.webp";